import "./lit-html.js"; /**
                        * @license
                        * Copyright 2020 Google LLC
                        * SPDX-License-Identifier: BSD-3-Clause
                        */
var o = function o(s) {
    return s.strings === void 0;
  },
  t = {},
  m = function m(s) {
    var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : t;
    return s._$AH = i;
  };
export { o as isSingleExpression, m as setCommittedValue };